/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

export function configureOrderList(list: any, LocalNetworkProfile: any, LocalUserPermissions: any): void {
  list.hasObjectSource = LocalNetworkProfile.hasObjectSource();
  list.orderFields = ['name', 'executionState', {param: 'externalReference', label: 'extReference'}, {param: 'Advertiser', label: 'advertiser'}, {param: 'Team', label: 'team'}, {param: 'Salesperson', label: 'salesperson'}, {param: 'AdOps', label: 'adOps'}, 'createUser', 'updateTime'];
  if (list.hasObjectSource) {
    list.orderFields.splice(1, 0, 'source');
  }
  if (!LocalUserPermissions.getAllVisPermissions().MANAGE_ADVERTISING) {
    list.orderFields = ['name', 'executionState', {param: 'externalReference', label: 'extReference'}, {param: 'Advertiser', label: 'advertiser'}, {param: 'Salesperson', label: 'salesperson'}, {param: 'AdOps', label: 'adOps'}, 'createUser', 'updateTime'];
  }

  list.orderFields.push({param: 'spendDelivery', numeric: true});
  list.orderFields.push({labelInstant: LocalNetworkProfile.getNetworkTranslations('impression'), param: 'impressionDelivery', numeric: true});
  list.orderFields.push({labelInstant: LocalNetworkProfile.getNetworkTranslations('rendered'), param: 'renderedDelivery', numeric: true});
  list.orderFields.push({param: 'viewableDelivery', numeric: true});
  list.orderFields.push({param: 'clickDelivery', numeric: true});
  list.orderFields.push({param: 'viewability', numeric: true});
  list.orderFields.push({param: '', label: 'eCpm', numeric: true});
  list.orderFields.push({param: '', label: 'cpc', numeric: true});
  list.orderFields.push({param: 'ctr', numeric: true});
  list.orderFields.push({param: 'elapsedTimePercentage', numeric: true});
  list.orderFields.push({param: 'deliveryPercentage', numeric: true});
  list.orderFields.push({param: 'budgetSpendPercentage', numeric: true});

  const skipForDefaults = ['source', 'createUser', 'spendDelivery', 'impressionDelivery', 'renderedDelivery', 'clickDelivery', 'viewableDelivery', 'viewability', 'eCpm', 'cpc', 'ctr', 'deliveryPercentage', 'budgetSpendPercentage'];
  list.defaultFields = _.filter(list.orderFields, (field: any) => {
    return skipForDefaults.indexOf(field.label || field.param || field) < 0;
  });
  list.sel = {};
  list.perms = LocalUserPermissions.getAllVisPermissions();

  list.applyLimitedFilter = function() {
    list.limitedFilter = true;
  };
}
